export const GET_PRODUCT_BY_SLUG = 'GET_PRODUCT_BY_SLUG'
export const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART'
export const UPDATE_TOTAL_CART = 'UPDATE_TOTAL_CART'
export const ORDER_PRODUCT = 'ORDER_PRODUCT'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CLEAR_CART = 'CLEAR_CART'
export const CHECK_ALL_CART = 'CHECK_ALL_CART'
export const UPDATE_ALL_CHECK = 'UPDATE_ALL_CHECK'
export const UPDATE_ITEMS_CART = 'UPDATE_ITEMS_CART'
